import React from 'react';
import Table from 'components/shared/table';
import { TYPES } from 'constants/config';
import { Button, Icon } from 'ui';

const InviteesTable = ({ invitees, onRemove }) => (
  <Table alternate className="mt-16 bdrs-small ov-h">
    <div className="Table-body">
      {invitees.map(invitee => (
        <Table.Row key={`${invitee.id}.${invitee.type}`}>
          <Table.BodyCell split className="fz-bigger">
            <div className="d-f jc-sb ai-c w-fill mr-16">
              <div>
                {invitee.type === TYPES.GROUP && (
                  <Icon name="group" className="mr-8 c-brand-gray-dark" />
                )}
                {invitee.name}
              </div>
              {invitee.type === TYPES.GROUP && (
                <span className="c-brand-gray-dark fz-sm">
                  {invitee.meta.usersCount} {t('common.people')}
                </span>
              )}
            </div>
            <div>
              <Button icon="delete" onClick={() => onRemove(invitee)} />
            </div>
          </Table.BodyCell>
        </Table.Row>
      ))}
    </div>
  </Table>
);

export default InviteesTable;
